import React from 'react'
import { useNavigate } from 'react-router'
import { useApiCompleteRegistration } from '../../api/account/apiUsers'
import { Button } from '../../genericComponents/Button'
import { Card } from '../../genericComponents/Card'
import { WizardWrapper } from '../WizardWrapper'

export const FTURegistrationCompleteCard: React.FC = () => {
  const navigate = useNavigate()

  const { mutate: registrationComplete } = useApiCompleteRegistration()

  const handleClick = () => {
    registrationComplete(undefined, {
      onSuccess: () => {
        void navigate('/login')
      },
    })
  }

  return (
    <Card title="">
      <WizardWrapper>
        <h1 className="text-primaryFontColor text-xl uppercase text-center tracking-[0.1em] font-bold m-3 my-6">
          We are all set!
        </h1>

        <div>
          <p className="self-center m-0 my-6">
            You have completed the onboarding setup. Next time you sign in please use your new
            password.
          </p>

          <Button className="w-full bg-primary text-white mt-4 uppercase" onClick={handleClick}>
            Continue
          </Button>
        </div>
      </WizardWrapper>
    </Card>
  )
}
